import Link from 'next/link'
import { useRef, useState, useEffect } from 'react'
import SlickSlider from 'react-slick'
import { ChevronLeft, ChevronRight } from 'components/icons'
import ArticoloCard from 'components/card/ArticoloCard'
import StrumentoCard from 'components/card/StrumentoCard'
import RaccoltaCard from 'components/card/RaccoltaCard'
import LezioneCard from 'components/card/LezioneCard'
import { UTENTE } from 'utils/endpoint'
import { api } from 'utils'

function BoxTemaDelMomento({ tema, variant = 'white', inTema = false, items = null }) {
  const [elementi, setElementi] = useState(items)

  useEffect(() => {
    if (items.length) checkTools()
  }, [items?.length])

  function checkTools() {
    const params = items.map(({ id, model }) => ({
      content_type_id: model,
      object_id: id,
    }))

    api.get(UTENTE + 'tools/', { params }).then((response) => {
      const enhancedItems = items.map((item) => {
        const current = response.data.find(
          (e) => e.content_type_id === item.model && e.object_id === item.id
        )

        const { saved, following, file_url, pdf_file } = current

        return { extra: { ...item.extra, file_url, pdf_file }, saved, following, ...item }
      })

      setElementi(enhancedItems)
    })
  }

  const renderCard = (item) => {
    switch (item.model_class) {
      case 'strumento':
        return <StrumentoCard strumento={item} />
      case 'articolo':
        return <ArticoloCard articolo={item} />
      case 'lezione':
        return <LezioneCard articolo={item} />
      default:
        return <RaccoltaCard raccolta={item} />
    }
  }

  let prev = useRef(null)
  let next = useRef(null)
  let slider = useRef(null)

  const sliderSettings = {
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    variableWidth: false,
    arrows: false,
    dots: false,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  }

  const handlePrev = () => {
    slider.slickPrev()
  }

  const handleNext = () => {
    slider.slickNext()
  }

  return (
    <div className={`box-tema-del-momento box-tema-del-momento--${variant}`}>
      <div className="box-tema-del-momento__container w-container-hub">
        <div className="box-tema-del-momento__content">
          {!inTema && <div className="box-tema-del-momento__intro">L’ARGOMENTO DEL MOMENTO</div>}
          <p className="box-tema-del-momento__title">{tema.titolo}</p>
          <div
            className="box-tema-del-momento__description"
            dangerouslySetInnerHTML={{ __html: tema.descrizione }}
          />
          <div className="box-tema-del-momento__cta-box">
            <Link legacyBehavior href={inTema ? `${tema.url}risorse` : tema.url}>
              <a className={`button button--primary ${!inTema ? 'button--inverted' : ''}`}>
                Lasciati ispirare
              </a>
            </Link>
          </div>
        </div>
        <div className="box-tema-del-momento__slider">
          <div className="box-tema-del-momento__slider-nav">
            <button
              className={`box-tema-del-momento__slider-nav-item box-tema-del-momento__slider-nav-item--prev`}
              onClick={handlePrev}
              ref={(self) => (prev = self)}
              aria-label={'Precedente'}
            >
              <ChevronLeft />
            </button>
            <button
              className={`box-tema-del-momento__slider-nav-item box-tema-del-momento__slider-nav-item--next`}
              onClick={handleNext}
              ref={(self) => (next = self)}
              aria-label={'Successivo'}
            >
              <ChevronRight />
            </button>
          </div>

          <SlickSlider ref={(self) => (slider = self)} {...sliderSettings}>
            {elementi.map((item) => renderCard(item))}
          </SlickSlider>
        </div>
      </div>
    </div>
  )
}

export default BoxTemaDelMomento
